import { useState } from "react"
import { InvoiceItem } from "@/api/invoices"
import { Token } from "@/config/tokens"
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible"

interface InvoiceItemsProps {
  items: InvoiceItem[];
  token: Token;
}

export default function InvoiceItems({ items = [], token }: InvoiceItemsProps) {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <Collapsible open={isOpen} onOpenChange={setIsOpen}>
      <CollapsibleTrigger
        className="text-white text-sm cursor-pointer"
        data-testid="view-details"
        isOpen={isOpen}
      >
        View details
      </CollapsibleTrigger>
      <CollapsibleContent>
        <table className="border rounded-md text-white p-2 font-normal border-separate mt-4 text-sm">
          <tr className="text-left">
            <th className="p-2">Description</th>
            <th className="p-2">Qty</th>
            <th className="p-2">Value</th>
            <th className="p-2">Subtotal</th>
          </tr>
          {items.map((item, index) => (
            <tr key={index}>
              <td className="p-2">{item.description}</td>
              <td className="p-2">{item.quantity}</td>
              <td className="p-2">
                {item.unitValue.toFixed(2)} {token}
              </td>
              <td className="p-2">
                {item.subtotal?.toFixed(2)} {token}
              </td>
            </tr>
          ))}
        </table>
      </CollapsibleContent>
    </Collapsible>
  )
}
